export enum IncomeFrequencyPeriodEnum {
  Yearly = 'YEARLY',
  Monthly = 'MONTHLY',
  // Hourly = 'HOURLY',
}